import request from '@/utils/request';
import BaseService from './base';

export interface CourseStructViewModel {
  id?: number;
  resID?: string;
  courseID?: number;
  bookID?: number;
  parentID?: number;
  level?: number;
  nodeType?: number;
  name?: string;
  introduce?: string;
  icon?: string;
  displayPos?: number;
  children?: CourseStructViewModel[];
  resCheckList?: string[];
  fullName?: string;
  displayName?: string;
}

export class CourseStructService extends BaseService<CourseStructViewModel> {
  protected serviceApi: string = 'CourseStruct';

  get NewModel(): CourseStructViewModel {
    return {
      id: 0,
      name: '',
      introduce: '',
      nodeType: 0,
      icon: '',
      displayPos: 0,
      children: [],
      fullName: '选择课程结点',
    };
  }

  public GetMaxPos(courseId: number, parentId: number) {
    return request({
      url: `${this.serviceApi}/GetMaxPos`,
      data: {courseID: courseId, parentID: parentId},
      method: 'post',
    });
  }

  public GetByCourseID(courseId: number) {
    return request({
      url: `${this.serviceApi}/GetByCourseID/${courseId}`,
      method: 'get',
    });
  }
  public GetByBookID(bookId: number) {
    return request({
      url: `${this.serviceApi}/GetByBookID/${bookId}`,
      method: 'get',
    });
  }
  public GetByBookGuid(bookId: string) {
    return request({
      url: `${this.serviceApi}/GetByBookGuid/${bookId}`,
      method: 'get',
    });
  }
}
